module.exports = __webpack_public_path__ + "static/media/IMG-1.44965610.jpg";